/* ============ o filme da home: coco, sachê em 3D, abre, enche ============
   O coco continua em camadas de PNG (2.5D). O sachê, a garrafa e o jato são WebGL (Three.js) num canvas
   transparente que fica entre a camada de trás e a da frente do coco. A câmera é fixa e tudo se move no
   plano z = 0, então posição e tamanho na tela se convertem direto para o mundo 3D. */
import * as THREE from "three";
const A = new URL("./", import.meta.url).href;   // os assets ficam na mesma pasta que este módulo
import { RoomEnvironment } from "three/addons/environments/RoomEnvironment.js";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { criarSache, criarGarrafa, criarGarrafaAgua, GARRAFINHA, criarJato, criarFundo, criarPlanoImagem, criarCaustica, criarSombra, criarEstudio, criarCoco, criarCocoVerde, criarCocoFoto, ativarSombra, iluminar, MEDIDAS, GARRAFA } from "sache3d";

const $ = s => document.querySelector(s), $$ = s => [].slice.call(document.querySelectorAll(s));
const reduz = matchMedia("(prefers-reduced-motion: reduce)").matches;
const params = new URLSearchParams(location.search);
/* celular e tablet (06/10, Matheus: "ainda trava bastante no celular"): perfil próprio, sem trocar o pixel ratio no meio
   da rolagem (cada troca realoca os buffers e dá um soluço), transmissão em meia resolução, sombra menor, rolagem que
   acompanha o dedo mais de perto e a barra do navegador que aparece e some sem reconfigurar a cena */
const TOQUE = matchMedia("(pointer: coarse)").matches || innerWidth < 900;
const uFixo = params.has("u") ? parseFloat(params.get("u")) : null;   // depuração: congela o filme num instante
const tFixo = params.has("t") ? parseFloat(params.get("t")) : null;

/* ---------- desempenho (05/10): escrever no DOM só o que mudou ----------
   O quadro roda a cada rolagem e, parado, enquanto o sachê "respira". Reescrever o mesmo estilo, a mesma classe ou o
   mesmo texto obriga o navegador a recalcular estilo e layout à toa; estes atalhos guardam o último valor escrito. */
let semDom = false;   // pré-compilação: o quadro de outro instante não toca no DOM
function est(el, prop, v){ if (semDom) return; const c = el.__c || (el.__c = {}); if (c[prop] !== v){ c[prop] = v; el.style[prop] = v; } }
function cls(el, nome, on){ if (semDom) return; const c = el.__c || (el.__c = {}), k = "." + nome; if (c[k] !== on){ c[k] = on; el.classList.toggle(nome, on); } }
function txt(el, v){ if (semDom) return; if (el.__t !== v){ el.__t = v; el.textContent = v; } }
function varCss(el, nome, v){ if (semDom) return; const c = el.__c || (el.__c = {}); if (c[nome] !== v){ c[nome] = v; el.style.setProperty(nome, v); } }
/* fatias de trabalho fora do quadro: requestIdleCallback quando existe (Safari não tem), senão um setTimeout curto */
const ocioso = () => new Promise(r => { if (window.requestIdleCallback) requestIdleCallback(() => r(), { timeout: 400 }); else setTimeout(r, 16); });

function trava(v,a,b){ return v < a ? a : (v > b ? b : v); }
function faixa(p,a,b){ return trava((p-a)/(b-a), 0, 1); }
function suave(t){ return t < .5 ? 4*t*t*t : 1 - Math.pow(-2*t+2,3)/2; }
function entre(a,b,t){ return a + (b-a)*t; }
function janela(p,a,b,m){ return Math.min(faixa(p,a,a+m), 1 - faixa(p,b-m,b)); }

const filme = $("#filme"), palco = $("#palco"), ambVerde = $("#ambVerde"), abertura = $("#abertura");
const camadasCoco = [$("#atoCocoTras"), $("#atoCocoFrente")];
const cocoTras = $("#cocoTras"), cocoFrente = $("#cocoFrente"), cocoTampa = $("#cocoTampa"), luz = $("#luz"), sombraCoco = $("#sombraCoco");
const cena3d = $("#cena3d"), ml = $("#ml");
const legendasCaixa = $("#legendas"), barraMobile = $("#barraMobile");
const legendas = $$(".legenda"), marcos = $$("#marcos span");
const railBarra = $("#railBarra"), role = $("#role");

/* ---------- paradas: o filme congela e o cartão entra ---------- */
const PARADAS = [
  { f:.345, d:.15, el:$("#cartaoSache") },
  { f:.996, d:.13, el:$("#cartaoComprar") }
];
let SOMA = 0; PARADAS.forEach(p => { SOMA += p.d; });
const ESC = 1 - SOMA;
function tempoFilme(u){
  let acc = 0;
  for (let i = 0; i < PARADAS.length; i++){
    const ini = PARADAS[i].f*ESC + acc;
    if (u < ini) break;
    if (u < ini + PARADAS[i].d) return PARADAS[i].f;
    acc += PARADAS[i].d;
  }
  return trava((u - acc)/ESC, 0, 1);
}
const CARTOES = (() => {
  let acc = 0; const lista = [];
  PARADAS.forEach((p, i) => {
    const ini = p.f*ESC + acc, fim = ini + p.d;
    lista.push({ el:p.el, entra:[ini - .004, ini + .03], sai:(i === PARADAS.length-1) ? [9,9] : [fim - .014, fim + .014] });
    acc += p.d;
  });
  return lista;
})();

/* ---------- medidas ---------- */
let vh = 900, vw = 1440, topoFilme = 0, altFilme = 1, largUltLeg = 0;
let quadrosSombra = 0;
// faixa livre para o sachê parado: entre o cabeçalho e o que vier primeiro, a legenda ou a trilha (Matheus, 25/09:
// a legenda passava por cima da base do sachê). Medida no layout (offsetTop ignora as transformações do quadro).
const trilha = $(".trilha");
let bandaTopo = 84, bandaBase = 780, aberturaCoco = { desce: 171, esc: .82 };
const topoCartoes = PARADAS.map(() => 0);   // offsetTop dos cartões (não muda com as transformações do quadro)
function medir(){
  /* altura do palco, não a da janela (06/10): no iPhone o palco tem 100vh (tela sem a barra do Safari) e a janela é menor
     com a barra à mostra; o canvas saía esticado e o coco da abertura descia para cima da trilha */
  vh = palco.clientHeight || innerHeight; vw = innerWidth;
  for (let k = 0; k < CARTOES.length; k++) topoCartoes[k] = CARTOES[k].el.offsetTop;
  largUltLeg = legendas[legendas.length - 1].offsetWidth;
  forcaSombra = true;
  topoFilme = filme.getBoundingClientRect().top + pageYOffset;   // 08/10: no Comprar o filme fica dentro do main (posicionado), e offsetTop contaria a partir dele
  altFilme = Math.max(1, filme.offsetHeight - vh);
  bandaTopo = 68 + 16;
  bandaBase = Math.min(legendasCaixa.offsetTop, trilha ? trilha.offsetTop : vh) - 14;
  if (bandaBase - bandaTopo < .3*vh) bandaBase = bandaTopo + .3*vh;   // tela muito baixa: melhor sobrepor do que sumir
  /* abertura (02/10): o coco desce até ficar abaixo dos botões do texto de abertura, que ficou mais longo; se não couber
     até a trilha, encolhe. Medidas sem transformação (offset*), a escala de abertura é .82 */
  const cena = $(".coco-cena"), acoesAb = abertura.querySelector(".acoes");
  const baseTexto = abertura.offsetTop + (acoesAb ? acoesAb.offsetTop + acoesAb.offsetHeight : abertura.offsetHeight) + 18;
  const hCena = cena ? cena.offsetHeight*1.06 : .4*vh;            // a caixa tem o translateY(6%) do CSS
  // o coco fica centrado na faixa entre os botões e a trilha, no tamanho de antes (.82) se couber
  const limite = (trilha ? trilha.offsetTop : vh) - 12;
  const esc0 = Math.max(.45, Math.min(.82, (limite - baseTexto)/hCena));
  const desce = (baseTexto + limite)/2 - vh/2 - .03*hCena;
  aberturaCoco = { desce, esc: esc0 };
  if (renderer){
    renderer.setSize(vw, vh, false);
    cam.aspect = vw/vh; cam.updateProjectionMatrix();
    const k = (DIST + 12)/DIST;
    fundo.mesh.scale.set(alturaMundo*k*(vw/vh) + .1, alturaMundo*k + .1, 1);
    const img = fundo.uniformes.tFoto.value && fundo.uniformes.tFoto.value.image;
    const iw = img && (img.videoWidth || img.width), ih = img && (img.videoHeight || img.height);
    if (iw && ih) fundo.uniformes.uAspecto.value = (vw/vh)/(iw/ih);
  }
}

/* ---------- cena 3D ---------- */
const DIST = 36, FOV = 28;
const alturaMundo = 2*DIST*Math.tan(FOV/2*Math.PI/180);      // altura visível em z = 0, em cm
const mundoX = px => (px/vw - .5)*alturaMundo*(vw/vh);
const mundoY = py => (.5 - py/vh)*alturaMundo;
const escalaPx = (pxAltura, cmAltura) => (pxAltura/vh)*alturaMundo/cmAltura;

/* o coco em 3D (malhas GLB geradas por IA): z do centro, inclinação para a câmera (mostra o corte e o furo), giro,
   altura em fração da caixa do DOM e as rotações que alinham cada malha (ver lab/coco.html) */
/* o coco fechado é cortado em corpo e tampa; no coco verde (criarCocoVerde, padrão desde 01/10) yCorte e raioSecao vêm dele e os daqui são ignorados */
/* qual coco (?coco=): "foto" (padrão desde 07/10: a casca é a própria foto de referência projetada numa malha com a silhueta
   dela, criarCocoFoto e lab/coco-foto.py; a IDCoco cobrava realismo), "verde" (de 01/10 a 06/10: malha gerada a partir da referência da IDCoco, assets/coco-verde.glb, cortada
   com cortar-glb.py --y .63), "codigo" (o coco verde feito em código, criarCocoVerde) ou "antigo" (assets/coco-fechado.glb, 25/09) */
const MODELO_COCO = ["foto", "verde", "codigo", "antigo"].includes(params.get("coco")) ? params.get("coco") : "foto";
const FOTO_NO_FILME = .32;   // força da praia por trás da animação, sob a máscara da cor do palco (0 desliga)
const COCO = Object.assign({ z: -1.4, incl: .42, giro: -.15, dy: -.04, raioFace: .37 }, {
  foto:   { altura: .86, dy: .03, deita: -.34, raioFuro: .19, env: .3 },   // yCorte e raioSecao vêm de criarCocoFoto
  verde:  { altura: .9, dy: .045, deita: -.34, yCorte: .13, raioSecao: .3039, raioFuro: .2, gotas: {} },
  codigo: { altura: .74, deita: -.34, yCorte: .18, raioSecao: .355, raioFuro: .225 },   // yCorte e raioSecao vêm de criarCocoVerde
  antigo: { altura: .9, deita: 0, yCorte: .18, raioSecao: .355, raioFuro: .225 }
}[MODELO_COCO]);
["z", "incl", "giro", "deita", "altura", "dy", "yCorte", "raioSecao", "raioFace", "raioFuro"].forEach(k => { if (params.has("coco_" + k)) COCO[k] = parseFloat(params.get("coco_" + k)); });

let renderer = null, cam, scene, sache, garrafa, garrafinha, jatoAgua, jato, fundo, cocoPlano = null, coco = null, sombraCocoPlano, caustica, pronto = false;
/* desempenho (05/10). A montagem da cena era uma tarefa só de meio segundo no celular, e os shaders da garrafa, da
   garrafinha e dos jatos eram compilados no meio da rolagem, quando apareciam (as "travadas às vezes"). Agora:
   - o que a abertura mostra (luz, coco e sachê) é montado em fatias curtas, e os shaders deles são compilados em
     paralelo (compileAsync) antes de o 3D assumir o lugar das imagens do coco, que são idênticas;
   - garrafa, garrafinha e jatos são montados depois, em tempo ocioso, e entram na cena só quando prontos;
   - por fim, todas as variantes de shader do filme inteiro são pré-compiladas percorrendo o filme sem desenhar.
   Se a pessoa chegar à garrafa antes disso, o que falta é montado na hora (como antes). */
let montarResto = () => {}, restoNaCena = false, forcaSombra = true, uSombra = NaN, tSombra = NaN;
const filaAlta = [], filaBaixa = [];
let filaRodando = false;
function agendarFila(){
  if (filaRodando) return;
  filaRodando = true;
  (async () => {
    while (filaAlta.length || filaBaixa.length){
      await ocioso();
      if (!renderer) break;
      const f = filaAlta.shift() || filaBaixa.shift();
      try { await f(); } catch (e){ console.error(e); }
    }
    filaRodando = false;
  })();
}
/* pixel ratio (05/10): teto 1,5 (antes 2 no desktop e 1,75 no celular; a 2 o desktop retina desenhava 5,2 Mpx por
   quadro). Na fase em que o sachê está sozinho e grande (sai do coco, cartão, close, rasgo) o rótulo perdia nitidez nas
   letras miúdas a 1,5, e essa é a fase mais leve (sem o passe de transmissão da garrafa), então ali volta ao teto
   antigo. Se o quadro passar de 22 ms em média, cai para 1,25 até folgar. ?pr=2 fixa um valor, para comparar */
const prFixo = params.has("pr") ? parseFloat(params.get("pr")) : null;
const PR_TETO = Math.min(devicePixelRatio || 1, 1.5), PR_BAIXO = Math.min(PR_TETO, 1.25);
const PR_CLOSE = TOQUE ? PR_TETO : Math.min(devicePixelRatio || 1, 2);
/* 20/10: degraus de queda para qualquer tela (antes só caía no desktop retina, de 1,5 para 1,25; tela comum e celular
   ficavam sem saída e travavam em placa de vídeo fraca). Abaixo de 1 o canvas é desenhado menor e esticado pelo CSS */
const NIVEIS = [...new Set([PR_TETO, PR_BAIXO, Math.min(PR_TETO, 1), Math.min(PR_TETO, .8), Math.min(PR_TETO, .65)])];
let prAtual = prFixo || PR_TETO, nivel = 0;
const prDesejado = p => prFixo || (nivel ? NIVEIS[nivel] : (p > .19 && p < .58 ? PR_CLOSE : PR_TETO));
try {
  if (params.has("sem3d")) throw new Error("depuração: sem 3D");
  renderer = new THREE.WebGLRenderer({ antialias:true, alpha:true, premultipliedAlpha:true, powerPreference:"high-performance" });
} catch (e){ renderer = null; }

if (!renderer){
  document.documentElement.classList.add("sem-3d");
} else {
  renderer.setPixelRatio(prAtual);
  renderer.toneMapping = THREE.NeutralToneMapping;
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFShadowMap;
  renderer.shadowMap.autoUpdate = false;     // o mapa de sombra só é redesenhado quando algo se mexe (ver o fim do quadro)
  renderer.localClippingEnabled = true;
  if (TOQUE) renderer.transmissionResolutionScale = .5;
  renderer.domElement.setAttribute("aria-hidden", "true");
  cena3d.appendChild(renderer.domElement);

  scene = new THREE.Scene();
  cam = new THREE.PerspectiveCamera(FOV, 1, 1, 200);
  cam.position.set(0, 0, DIST);
  cam.lookAt(0, 0, 0);
  // a luz chave é rasante e só ilumina. Quem projeta sombra é uma luz um pouco acima e à esquerda da câmera, com
  // intensidade de verdade (antes era .02, só para o plano de fundo): assim a tampa sombreia a polpa, o sachê
  // sombreia o coco e a sombra no fundo cai curta, atrás do objeto.
  const luzSombra = new THREE.DirectionalLight("#ffffff", .38);
  luzSombra.position.set(-6, 9, 28);
  ativarSombra(luzSombra, TOQUE ? { tam: 512 } : undefined);
  scene.add(luzSombra);

  // plano que só recebe sombra, logo atrás do plano z = 0
  const chao = new THREE.Mesh(new THREE.PlaneGeometry(120, 120), new THREE.ShadowMaterial({ color:"#1f2614", opacity:.16 }));
  chao.position.z = -1.6; chao.receiveShadow = true;
  scene.add(chao);

  // o fundo do palco vive dentro da cena, porque a água refrata o que está atrás dela
  fundo = criarFundo();
  fundo.mesh.position.z = -12;
  scene.add(fundo.mesh);

  sombraCocoPlano = criarSombra(); sombraCocoPlano.rotation.x = 0; sombraCocoPlano.position.z = -1.3;
  scene.add(sombraCocoPlano);

  // reflexos de estúdio (PMREM): primeira fatia, antes de qualquer material ser compilado (as luzes entram no shader)
  filaAlta.push(() => iluminar(scene, renderer, RoomEnvironment, { chave:.95, env:.85 }));

  /* o resto do filme, em fatias ociosas; os objetos ficam fora da cena até tudo estar pronto */
  let estudio = null;
  filaBaixa.push(() => { estudio = criarEstudio(renderer); });
  filaBaixa.push(() => {
    garrafa = criarGarrafa(estudio);
    garrafa.tampa.traverse(m => { if (m.isMesh) m.castShadow = true; });
    garrafa.grupo.visible = false;
    caustica = criarCaustica(); caustica.visible = false;
  });
  filaBaixa.push(() => {
    jato = criarJato();
    jato.mesh.visible = false;
    // depois do gel, a água mineral: garrafinha PET e um fio de água limpa, mais grosso que o do gel
    garrafinha = criarGarrafaAgua(estudio);
    garrafinha.grupo.visible = false;
    jatoAgua = criarJato({ attenuationColor:new THREE.Color("#f1f7f8"), attenuationDistance:9, roughness:.04, ior:1.33, thickness:.5, envMapIntensity:.9 });
    jatoAgua.mesh.visible = false;
  });
  filaBaixa.push(() => { if (pronto) entrarResto(); });
  montarResto = () => {   // chamado pelo quadro se a pessoa chegar à garrafa antes das fatias
    while (filaBaixa.length) filaBaixa.shift()();
    if (!estudio) estudio = criarEstudio(renderer);
    entrarResto();
  };

  const loader = new THREE.TextureLoader();
  // sem crossOrigin: a mesma origem não precisa de CORS no WebGL, e assim o navegador reaproveita as imagens que o HTML
  // já pré-carregou (com "anonymous" ele baixava de novo o sachê, o coco e a praia)
  loader.setCrossOrigin(undefined);
  const vertical = innerWidth/innerHeight < .9;
  // foto de impacto da abertura (02/10): praia da Bahia, vertical no celular; carrega à parte para não atrasar o filme
  if (!params.has("claro")) loader.loadAsync(vertical ? (A + "heroi-praia-vertical.webp") : (A + "heroi-praia.webp")).then(t => {
    t.minFilter = THREE.LinearFilter; t.generateMipmaps = false;
    if (!(fundo.uniformes.tFoto.value && fundo.uniformes.tFoto.value.isVideoTexture)) fundo.uniformes.tFoto.value = t;
    medir(); if (pronto) quadro(uAtual, tempoAgora());
  }).catch(() => {});
  if (params.has("semBitmap")) window.createImageBitmap = undefined;   // depuração: o headless com tempo virtual trava no ImageBitmap
  const gltf = new GLTFLoader();
  /* coco (05/10): malha comprimida com meshopt e textura de 1024 (370 KB no lugar de 1,6 MB). O decodificador vem por
     import dinâmico: se faltar (pacote de arquivo único), carrega o GLB original. ?glb=orig força o original */
  const usarOpt = MODELO_COCO === "verde" && params.get("glb") !== "orig";
  const meshopt = usarOpt ? import("three/addons/libs/meshopt_decoder.module.js").then(m => m.MeshoptDecoder.ready.then(() => m.MeshoptDecoder)).catch(() => null) : Promise.resolve(null);
  const glb = u => gltf.loadAsync(u).then(g => g.scene).catch(() => null);   // sem GLB, o coco continua em 2.5D
  const carregarCoco = () => meshopt.then(dec => {
    if (dec){ gltf.setMeshoptDecoder(dec); return glb((A + "coco-verde-opt.glb")).then(g => g || glb((A + "coco-verde.glb"))); }
    return glb(MODELO_COCO === "verde" ? (A + "coco-verde.glb") : window.__glb);
  });
  const coco2d = params.has("coco2d");
  Promise.all([
    loader.loadAsync((A + "sache-frente.webp")),
    loader.loadAsync((A + "sache-verso.webp")),
    loader.loadAsync((A + "sache-normal.webp")),
    null,   // a camada de trás do coco em 2.5D (coco3d-corpo) só é pedida se o GLB faltar
    coco2d ? null : MODELO_COCO === "foto" ? loader.loadAsync((A + "coco-foto.webp")).then(t => criarCocoFoto(t)).catch(() => null)
      : MODELO_COCO === "codigo" ? criarCocoVerde() : carregarCoco(),
    coco2d ? null : loader.loadAsync((A + "coco-face.webp")).catch(() => null),
    coco2d ? null : loader.loadAsync((A + "coco-tampa-polpa.webp")).catch(() => null)
  ]).then(async ([tf, tv, tn, tc, gCoco, tFace, tPolpa]) => {
    if (!gCoco && !tc) tc = await loader.loadAsync((A + "coco3d-corpo.webp"));   // sem o GLB: o coco em 2.5D
    filaAlta.push(() => {
      if (gCoco){
        coco = criarCoco(gCoco, Object.assign({ texFace: tFace, texPolpaTampa: tPolpa }, COCO));
        sombraCocoPlano.position.z = COCO.z - 3.3;
      } else {
        cocoPlano = criarPlanoImagem(tc); cocoPlano.position.z = -1.2;
      }
    });
    filaAlta.push(() => {
      sache = criarSache(tf, tv, renderer, {}, tn);
      sache.grupo.traverse(m => { if (m.isMesh) m.castShadow = true; });
      sache.tira.children.forEach(c => { c.material = c.material.clone(); c.material.transparent = true; });
      sache.grupo.traverse(m => { if (m.isMesh) m.material.clipShadows = true; });   // a parte submersa não projeta sombra no coco
    });
    // envio das texturas à GPU, uma por fatia (a decodificação de uma imagem grande custa dezenas de ms no celular)
    [tf, tv, tn, tFace, tPolpa, tc].forEach(t => { if (t) filaAlta.push(() => renderer.initTexture(t)); });
    filaAlta.push(() => {
      const mapas = new Set();
      if (coco) coco.grupo.traverse(m => { if (m.isMesh && m.material.map) mapas.add(m.material.map); });
      mapas.forEach(t => filaAlta.unshift(() => renderer.initTexture(t)));
    });
    filaAlta.push(revelar);
    agendarFila();
  }).catch(() => { document.documentElement.classList.add("sem-3d"); renderer = null; });
  agendarFila();
}

/* o 3D assume: compila os shaders da abertura em paralelo e só então troca as imagens do coco pela cena */
async function revelar(){
  if (coco) scene.add(coco.grupo);
  if (cocoPlano) scene.add(cocoPlano);
  scene.add(sache.grupo);
  montado = true;
  quadro(uAtual, tempoAgora(), ESTADO);          // materiais no estado do instante atual (recorte, transparência)
  try { await renderer.compileAsync(scene, cam); } catch (e){}
  if (!renderer) return;
  if (coco){
    [cocoTras, cocoFrente, cocoTampa, sombraCoco].forEach(e => { e.style.visibility = "hidden"; });   // o coco inteiro está na cena
  } else {
    cocoTras.style.visibility = "hidden"; sombraCoco.style.visibility = "hidden";   // agora estão dentro da cena
    [cocoTras, cocoFrente].forEach(e => { if (!e.getAttribute("src") && e.dataset.src) e.src = e.dataset.src; });   // o corpo aberto só é baixado aqui (20/10)
    cocoFrente.style.visibility = "visible"; cocoTampa.src = (A + "coco3d-tampa.webp");   // 2.5D: corpo aberto e tampa separada, para abrir
  }
  pronto = true;
  document.documentElement.classList.remove("sem-3d");   // se a rede de segurança do HTML desistiu antes da hora (rede lenta), volta ao 3D
  medir(); lerScroll(); quadro(uAtual, tempoAgora());
  if (restoNaCena) aquecer(); else if (!filaBaixa.length && garrafinha) entrarResto();
}
let montado = false;
function entrarResto(){
  if (restoNaCena || !garrafinha) return;
  scene.add(garrafa.grupo, caustica, jato.mesh, garrafinha.grupo, jatoAgua.mesh);
  restoNaCena = true;
  aquecer();
}

/* pré-compilação do filme inteiro (05/10): para cada instante, põe a cena no estado dele sem desenhar, compila em
   paralelo o que faltar (inclusive as variantes do passe de transmissão, em que a cena opaca é desenhada numa textura
   linear para a água e o vidro refratarem) e faz um desenho de 1 pixel para as sombras; depois volta ao instante atual
   na mesma tarefa, então nada intermediário chega à tela */
let aquecendo = false;
async function aquecer(){
  if (aquecendo || !renderer || !pronto) return;
  aquecendo = true;
  const alvo = new THREE.WebGLRenderTarget(1, 1, { type: THREE.HalfFloatType });
  const lista = [];
  for (let u = 0; u <= 1.0001; u += .05) lista.push(Math.min(1, u));
  for (const u of lista){
    await ocioso();
    if (!renderer || document.hidden){ if (document.hidden) await new Promise(r => document.addEventListener("visibilitychange", r, { once: true })); if (!renderer) break; }
    const antes = renderer.info.programs.length;
    quadro(u, tempoAgora(), ESTADO);
    const esperas = [renderer.compileAsync(scene, cam)];
    if ((garrafa.grupo.visible || garrafinha.grupo.visible || jato.mesh.visible || jatoAgua.mesh.visible)){
      renderer.setRenderTarget(alvo);
      scene.traverseVisible(o => {
        if (o.isMesh && o.material && !o.material.transparent && !(o.material.transmission > 0)) esperas.push(renderer.compileAsync(o, cam, scene));
      });
      renderer.setRenderTarget(null);
    }
    quadro(uAtual, tempoAgora(), ESTADO);
    try { await Promise.all(esperas); } catch (e){}
    if (!renderer) break;
    await ocioso();
    if (!renderer) break;
    // sombras e o que só existe no desenho: 1 pixel, e o quadro de verdade logo em seguida
    quadro(u, tempoAgora(), AQUECER);
    quadro(uAtual, tempoAgora());
    if (window.__logAquecer) console.log("aquecer u=" + u.toFixed(2) + " programas " + antes + " -> " + renderer.info.programs.length);
  }
  alvo.dispose();
  aquecendo = false;
  window.__aquecido = true;
}

/* ---------- o quadro ---------- */
const JANELAS = [[.05,.20],[.195,.36],[.44,.585],[.66,1.03]];
const rad = g => g*Math.PI/180;
const vTmp = new THREE.Vector3(), vTmp2 = new THREE.Vector3(), vTmp3 = new THREE.Vector3(), qTmp = new THREE.Quaternion(), eTmp = new THREE.Euler(), mTmp = new THREE.Matrix4();
const GEL_NIVEL = GARRAFA.GEL;                // o gel para na marca de 37 mL estampada na garrafa
const planoAgua = new THREE.Plane();          // corta o sachê pela superfície da água do coco enquanto ele emerge
const pontosJato = [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()];

const ESTADO = 1, AQUECER = 2;   // modos do quadro: só aplicar o estado (sem desenhar) e desenhar 1 pixel (pré-compilação)
let quadro = function(u, t, modo){
  const p = tempoFilme(u);
  semDom = modo === ESTADO || modo === AQUECER;

  /* leituras de layout primeiro */
  const rC = cocoFrente.getBoundingClientRect();

  const opAb = 1 - faixa(u, 0, .04);
  est(abertura, "opacity", opAb);
  est(abertura, "transform", "translateY(" + (-24*(1-opAb)) + "px)");
  est(abertura, "pointerEvents", opAb > .5 ? "auto" : "none");

  const estreito = vw < 900 && !(vw > vh && vh < 520); let visCartao = 0, topoCartao = vh;
  for (let k = 0; k < CARTOES.length; k++){
    const cc = CARTOES[k];
    const v = Math.min(faixa(u, cc.entra[0], cc.entra[1]), 1 - faixa(u, cc.sai[0], cc.sai[1]));
    if (v > .002 && topoCartoes[k] < topoCartao) topoCartao = topoCartoes[k];   // no celular o cartão sobe de baixo e entra na faixa livre
    est(cc.el, "opacity", v);
    est(cc.el, "visibility", v > .002 ? "visible" : "hidden");
    est(cc.el, "transform", estreito ? "translateY(" + (40 - 40*v) + "px)" : "translate(" + (44 - 44*v) + "px,-50%)");
    if (v > visCartao) visCartao = v;
  }
  const deslocX = estreito ? 0 : -(vw < 900 ? .27*vw : Math.min(vw*.15, 210))*visCartao;   // celular deitado: o cartão ocupa quase metade da tela
  const deslocY = estreito ? -.085*vh*visCartao : 0;
  /* garrafa (05/10): no celular, quando o cartão de compra sobe, ela vai para o centro e cabe inteira acima dele
     (antes o cartão cobria a garrafa do meio para baixo). No desktop fica como era */
  const gBaseY = estreito ? entre(vh*.82 + deslocY, Math.min(vh*.82, topoCartao - 22), visCartao) : vh*.88 + deslocY;
  const hGarPx = estreito ? Math.min(.38*vh, entre(.38*vh, (gBaseY - bandaTopo - 8)/1.2, visCartao)) : .44*vh;
  const gOffX = estreito ? .17*(1 - visCartao) : .21;
  const escCena = 1 - .12*visCartao;

  if (barraMobile) cls(barraMobile, "dentro", u > .26);   // no Comprar a barra é a da ficha, cuidada pelo loja.js

  est(ambVerde, "transform", "translate(calc(-50% + " + deslocX + "px), calc(-50% + " + deslocY + "px)) scale(" + (.9 + .25*faixa(p,.06,.30)) + ")");

  /* ====== ato 1: o coco abre (camadas 2.5D) ====== */
  const pTampa = suave(faixa(p, .03, .16));
  est(cocoTampa, "transform", "translate(" + (-22*pTampa) + "%," + (-34*pTampa) + "%) rotate(" + (-21*pTampa) + "deg) scale(" + (1 - .1*pTampa) + ")");
  est(cocoTampa, "opacity", 1 - faixa(p, .15, .25));

  const pLuz = faixa(p, .06, .18);
  est(luz, "opacity", pLuz*(1 - faixa(p, .20, .30))*(coco ? 0 : 1));   // em 3D o brilho do DOM lavava o topo do coco
  est(luz, "transform", "translate(-50%,-50%) scale(" + (.4 + 1.15*pLuz) + ")");

  const pCorpo = suave(faixa(p, .18, .30));
  const tCorpo = "translateY(" + (30*pCorpo) + "%) scale(" + (1 - .08*pCorpo) + ")";
  est(cocoFrente, "transform", tCorpo);
  est(cocoTras, "transform", tCorpo);
  est(cocoFrente, "opacity", 1 - faixa(p, .20, .30));
  est(cocoTras, "opacity", 1 - faixa(p, .20, .28));
  est(sombraCoco, "opacity", .5*(1 - faixa(p, .18, .30)));

  const opCoco = 1 - faixa(p, .30, .34);
  const tCoco = "translate(" + deslocX + "px," + (deslocY + aberturaCoco.desce*opAb) + "px) scale(" + (escCena*(1 - (1 - aberturaCoco.esc)*opAb)) + ")";
  camadasCoco.forEach(c => {
    est(c, "opacity", opCoco);
    est(c, "transform", tCoco);
    cls(c, "fora", opCoco < .002);
  });

  /* ====== legendas, trilha, dica ====== */
  let ativo = 0;
  for (let j = 0; j < legendas.length; j++){
    const w = JANELAS[j];
    const op = janela(p, w[0], w[1], .035);
    est(legendas[j], "opacity", op);
    est(legendas[j], "transform", "translateY(" + (10 - 10*op) + "px)");
    if (p >= w[0]) ativo = j;
  }
  for (let m = 0; m < marcos.length; m++) cls(marcos[m], "ativo", m === ativo);
  let txLeg = deslocX - (estreito ? (vw < 721 ? .23 : .2)*vw*suave(faixa(p, .62, .70)) : 0);
  // a última legenda (à esquerda da garrafa) não pode passar da margem: no celular saía cortada pela borda (06/10)
  if (estreito && p > .55) txLeg = Math.max(txLeg, 18 - (vw - largUltLeg)/2);
  est(legendasCaixa, "transform", "translate(" + txLeg + "px," + deslocY + "px)");
  est(legendasCaixa, "opacity", estreito ? (1 - visCartao) : 1);
  if (trilha) est(trilha, "opacity", estreito ? (1 - visCartao) : 1);   // no celular o cartão sobe por cima da trilha: ela sai junto com a legenda
  est(railBarra, "transform", "scaleX(" + u + ")");   // escala em vez de largura: não recalcula layout
  cls(role, "saiu", u > .012);

  if (!montado) return;
  if (p > .5 && !restoNaCena) montarResto();     // chegou à garrafa antes das fatias ociosas: monta agora
  const comResto = restoNaCena;

  /* ====== fundo e camada de trás do coco, dentro da cena ====== */
  const escHalo = .9 + .25*faixa(p, .06, .30), raioHalo = Math.min(1.2*vh, .9*vw)/2*escHalo;
  /* estúdio escuro (01/10): a luz cai quando a tampa sai e o coco e o sachê aparecem em verde-mata com um refletor atrás;
     volta ao creme quando o sachê é rasgado, a tempo da garrafa (a água refrata o fundo, e no escuro a água de coco
     ficava preta). Legendas, trilha e cabeçalho acompanham pela variável --escuro e pela classe palco-escuro. */
  // com a foto, o escuro entra no mesmo intervalo em que a praia sai: as duas camadas se cruzam sem o creme aparecer no meio
  const fotoPronta = !!fundo.uniformes.tFoto.value;
  const escuro = params.has("claro") ? 0 : suave(fotoPronta ? faixa(p, .015, .065) : faixa(p, .025, .07))*(1 - suave(faixa(p, .565, .615)));
  fundo.uniformes.uEscuro.value = escuro;
  // com a foto da praia carregada, ela passa direto para o estúdio escuro (sem o pistache claro no meio, que deixava a
  // tela lavada por um instante); o pistache só fica como abertura se a foto não carregar
  const temFoto = !!fundo.uniformes.tFoto.value;
  fundo.uniformes.uInicio.value = params.has("claro") || temFoto ? 0 : 1 - suave(faixa(p, .02, .07));
  const foto = temFoto ? 1 - suave(faixa(p, .015, .065)) : 0;   // a praia some no mesmo ritmo em que o escuro entra
  fundo.uniformes.uFoto.value = foto;
  // praia fraca por trás de toda a animação (teste de 02/10). Para voltar como era: FOTO_NO_FILME = 0 (ou ?semfotofundo=1)
  fundo.uniformes.uFotoFraca.value = temFoto && !params.has("semfotofundo") ? FOTO_NO_FILME*(1 - foto) : 0;
  // texto da abertura fica claro até sumir de vez (antes escurecia no meio do esmaecimento, quando a foto passava de 50%)
  cls(palco, "com-foto", temFoto && (foto > .01 || opAb > 0));
  // 06/10: com a praia nova, nítida, as ondas paradas por trás do filme apareciam (Matheus). O vídeo segue tocando
  // enquanto a praia aparece, inteira na abertura ou fraca atrás da animação
  if (!semDom){ fotoAtual = temFoto ? Math.max(foto, fundo.uniformes.uFotoFraca.value) : 0; cuidarVideo(); }   // abertura em pistache; depois o escuro e, na garrafa, o creme
  varCss(palco, "--escuro", suave(faixa(escuro, .3, .7)).toFixed(3));   // o texto troca de cor mais depressa que o fundo, para não passar por um meio-tom sem contraste
  // cabeçalho escuro do início do filme até o palco voltar ao creme (na garrafa); antes ele clareava entre a praia e o
  // estúdio escuro e piscava (Matheus, 02/10)
  // no Comprar (08/10) o filme vem depois da ficha do produto: o cabeçalho só escurece quando o filme chega ao topo
  cls(document.body, "palco-escuro", p < .59 && u < .999 && (topoFilme < 50 || pageYOffset >= topoFilme - 60));
  // na cena da garrafa o halo vai para trás dela (ficava no centro, onde estava o sachê, e a luz parecia fora do lugar)
  const pHaloG = suave(faixa(p, .56, .66));
  const hxG = .5 + deslocX/vw + gOffX, hyG = (gBaseY - .5*hGarPx)/vh;
  fundo.uniformes.uHalo.value.set(entre(.5 + deslocX/vw, hxG, pHaloG), entre(.48 + deslocY/vh, hyG, pHaloG), raioHalo/vw*(1 - .25*pHaloG), raioHalo/vh*(1 - .25*pHaloG));
  const cxC = mundoX(rC.left + rC.width/2), cyC = mundoY(rC.top + rC.height/2), hC = rC.height/vh*alturaMundo;
  let yAguaPx = rC.top + rC.height/2;                                // altura da água do coco na tela (definida no bloco do coco)
  if (cocoPlano){
    const opTras = (1 - faixa(p, .20, .28))*opCoco;
    cocoPlano.visible = opTras > .002;
    cocoPlano.material.opacity = opTras;
    cocoPlano.position.x = cxC; cocoPlano.position.y = cyC;
    cocoPlano.scale.set(rC.width/vh*alturaMundo, hC, 1);
  }
  /* ====== o coco em 3D: a tampa voa, o corpo afunda e encolhe enquanto o sachê sai, depois some ====== */
  if (coco){
    const esc = hC*COCO.altura;
    // o coco não some: depois que o sachê sai, o corpo cai para fora da tela por baixo (Matheus, 25/09)
    const pDesce = suave(faixa(p, .17, .30));
    const yCentro = cyC + COCO.dy*hC;
    const yFora = -alturaMundo/2 - .75*esc - 1;                    // o ponto mais alto da borda fica abaixo da tela
    coco.grupo.visible = pDesce < 1;
    coco.grupo.position.set(cxC, entre(yCentro, yFora, pDesce), COCO.z);
    coco.grupo.scale.setScalar(esc);
    // o coco começa deitado para o lado, como na foto de referência da IDCoco, e se endireita enquanto a tampa abre
    coco.grupo.rotation.set(COCO.incl, COCO.giro, COCO.deita*(1 - suave(faixa(p, .02, .12))));
    // a tampa vira para cima e para a esquerda (fora do caminho do sachê) e depois segue para a esquerda até sair da tela.
    // Ela é filha do corpo, então compensa a queda dele: o deslocamento vertical do mundo levado para o espaço local
    const pFora = suave(faixa(p, .16, .28));
    const xFora = (-alturaMundo*(vw/vh)/2 - 2.2*coco.raioSecao*esc - 2 - cxC)/esc;   // em unidades locais do coco
    qTmp.copy(coco.grupo.quaternion).invert();
    vTmp.set(0, yCentro - coco.grupo.position.y, 0).applyQuaternion(qTmp).divideScalar(esc);
    coco.tampa.visible = pFora < 1;
    coco.tampa.position.set(entre(-.6*pTampa, xFora, pFora) + vTmp.x, coco.yCorte + .46*pTampa + .2*pFora + vTmp.y, -.35*pTampa + vTmp.z);
    coco.tampa.rotation.set(-.35*pTampa, 0, .5*pTampa + .25*pFora);
    coco.tampa.scale.setScalar(1 - .18*pTampa);
    // a superfície da água, no mundo (inclinada e caindo com o coco), e a altura dela em pixels no plano do sachê (z = 0)
    coco.grupo.updateMatrixWorld(true);
    planoAgua.setFromNormalAndCoplanarPoint(vTmp.set(0, 1, 0), vTmp2.set(0, coco.yAgua, 0)).applyMatrix4(coco.grupo.matrixWorld);
    const yAguaMundo = -(planoAgua.normal.x*cxC + planoAgua.constant)/planoAgua.normal.y;
    yAguaPx = (.5 - yAguaMundo/alturaMundo)*vh;
  }

  const opSombraC = coco ? .7*opCoco : .5*(1 - faixa(p, .18, .30))*opCoco;
  sombraCocoPlano.visible = opSombraC > .002;
  sombraCocoPlano.material.opacity = opSombraC;
  const kS = (DIST - sombraCocoPlano.position.z)/DIST;             // a sombra fica atrás do plano z = 0: compensa a perspectiva
  const quedaCoco = coco ? coco.grupo.position.y - (cyC + COCO.dy*hC) : 0;   // em 3D a sombra cai junto com o coco
  sombraCocoPlano.position.x = cxC*kS; const yBaseCoco = coco && MODELO_COCO !== "antigo" ? cyC + (COCO.dy - .5*COCO.altura)*hC : mundoY(rC.top + rC.height*1.01);   // o coco verde é menor que a caixa: a sombra acompanha a base dele
  sombraCocoPlano.position.y = (yBaseCoco + quedaCoco)*kS;
  sombraCocoPlano.scale.set((coco ? .5 : .44)*rC.width/vh*alturaMundo*kS, (coco ? .07 : .05)*hC*kS, 1);


  /* ====== ato 2: o sachê sobe do coco e vem para a frente girando ====== */
  const pSai = suave(faixa(p, .09, .22));
  const pVem = suave(faixa(p, .20, .315));
  const opS = coco ? 1 : faixa(p, .09, .13);   // em 3D existe desde o início, submerso: a água o esconde até ele subir
  const pSobe = suave(faixa(p, .765, .815));     // depois do gel o sachê sobe e sai pela parte de cima (não some), abrindo espaço para a água

  // tamanho e posição em pixels, depois convertidos para o mundo
  const hDentro = (coco ? .72 : 1.15)*rC.width;                    // em 3D cabe no furo enquanto atravessa a face; cresce depois
  // no celular, com o cartão visível, a faixa livre termina em cima dele (e o deslocamento vertical fica por conta da faixa)
  const baseEf = estreito ? entre(bandaBase, Math.min(bandaBase, topoCartao - 14), visCartao) : bandaBase;
  const bandaAlt = Math.max(.3*vh, baseEf - bandaTopo), bandaMeio = (bandaTopo + baseEf)/2 - (estreito ? deslocY : 0);
  const hHeroi = Math.min(estreito ? .62*vh : .76*vh, bandaAlt/1.08);   // no centro da faixa livre; a folga é para o giro em perspectiva
  const cxCoco = rC.left + rC.width/2, cyCoco = rC.top + rC.height/2;
  // 3D: começa inteiro abaixo da superfície da água (a ponta a 3% da altura do coco abaixo dela, mais a amplitude da
  // flutuação), então ele emerge da água em vez de aparecer com a ponta já de fora (Matheus, 25/09). 2.5D: atrás da frente
  const yDentro = coco ? yAguaPx + .5*hDentro*1.06 + .051*hDentro + .03*rC.height : cyCoco + .28*rC.height;
  // pairando acima do coco. Em 3D sobe pouco (o topo fica abaixo do cabeçalho); quem abre a folga é o coco afundando
  const ySaiu = coco ? Math.max(rC.top - .06*rC.height, 84 + .5*hDentro) : rC.top - .02*rC.height;
  const cxHeroi = vw/2 + deslocX, cyHeroi = bandaMeio + deslocY;

  let sx = entre(cxCoco, cxHeroi, pVem);
  let sy = entre(entre(yDentro, ySaiu, pSai), cyHeroi, pVem);
  let sh = entre(hDentro, hHeroi, pVem);
  // giro completo na vinda, terminando num três quartos
  let ry = pVem*(Math.PI*2 + .55), rx = -.12*pVem, rz = 0;

  /* ====== ato 3: aproxima, rasga a tira ====== */
  const pZoom = suave(faixa(p, .37, .46));
  const pTira = suave(faixa(p, .47, .57));
  sx = entre(sx, vw/2 + deslocX, pZoom);
  sy = entre(sy, bandaMeio + deslocY, pZoom);
  sh = entre(sh, Math.min((estreito ? .6 : .72)*vh, bandaAlt/1.05), pZoom);
  ry = entre(ry, Math.PI*2 + .28, pZoom);       // segue no mesmo sentido, sem desandar a volta
  rx = entre(rx, -.08, pZoom);
  rz = .05*Math.sin(pTira*Math.PI*3)*(1 - pTira);

  /* ====== ato 4: inclina e despeja na garrafa ====== */
  const pDesp = suave(faixa(p, .58, .67));
  const pGar = suave(faixa(p, .555, .635));       // a garrafa entra enquanto o sachê vira
  const pSubGar = suave(faixa(p, .94, 1));
  const hGar = hGarPx;                                              // altura da garrafa na tela (sem tampa)
  const escG = escalaPx(hGar, GARRAFA.ALT_BOCA)*escCena;
  const gx = mundoX(vw/2 + deslocX + gOffX*vw);
  const gyBase = mundoY(gBaseY);
  const gyEntra = gyBase - alturaMundo*.9*(1 - pGar);
  if (comResto){   // garrafa montada (antes dela, p < .5, nada disso aparece)
    garrafa.grupo.visible = pGar > 0 && p < 1.01;
    garrafa.grupo.position.set(gx, gyEntra + .03*alturaMundo*pSubGar, 0);
    garrafa.grupo.scale.setScalar(escG);
    garrafa.grupo.rotation.set(.045, -.5 + .2*pSubGar, 0);          // leve inclinação para a câmera: mostra a superfície da água
    // a tampa salta da boca, voa para a direita até fora da tela e volta no fim, rosqueando na garrafa cheia (Matheus, 25/09)
    const pTampaG = suave(faixa(p, .62, .665));     // a tampa sai antes de o sachê terminar de virar
    const pForaT = suave(faixa(p, .645, .80));
    const pVoltaT = suave(faixa(p, .945, .992));
    garrafa.grupo.updateMatrixWorld(true);
    vTmp.set(alturaMundo*(vw/vh)/2 + 2.5*escG + 2, garrafa.grupo.position.y + (GARRAFA.ALT_BOCA + 6)*escG, 0);
    garrafa.grupo.worldToLocal(vTmp);                 // fora da tela, à direita, em coordenadas locais da garrafa
    let tx = 2.4*pTampaG + 2.2*pTampaG*pTampaG, ty = GARRAFA.ALT_BOCA + 3.2*pTampaG, tz = .6*pTampaG;
    tx = entre(tx, vTmp.x, pForaT); ty = entre(ty, vTmp.y, pForaT) + 2.5*Math.sin(Math.PI*pForaT); tz = entre(tz, vTmp.z, pForaT);
    let tRx = -.3*pTampaG - .4*pForaT, tRy = 6.2*pTampaG + 3*pForaT, tRz = -.9*pTampaG - .6*pForaT;
    if (pVoltaT > 0){
      tx = entre(vTmp.x, 0, pVoltaT); ty = entre(vTmp.y, GARRAFA.ALT_BOCA, pVoltaT) + 3.5*Math.sin(Math.PI*pVoltaT); tz = entre(vTmp.z, 0, pVoltaT);
      tRx = entre(-.7, 0, pVoltaT); tRy = entre(9.2, 0, pVoltaT); tRz = entre(-1.5, 0, pVoltaT);   // gira ao pousar, como se rosqueasse
    }
    garrafa.tampa.position.set(tx, ty, tz);
    garrafa.tampa.rotation.set(tRx, tRy, tRz);
    garrafa.tampa.visible = !(pForaT >= 1 && pVoltaT <= 0);
  }
  // ordem pedida pela IDCoco (30/09): a garrafa chega vazia, primeiro cai o gel, que forma uma camada densa no fundo;
  // depois a água mineral entra, sobe o nível e dilui o gel até virar água de coco
  const pGel = faixa(p, .68, .76), pAgua = faixa(p, .805, .91);
  const nivelGel = GEL_NIVEL*suave(pGel);
  const nivelG = entre(nivelGel, GARRAFA.NIVEL, pAgua);
  txt(ml, Math.round(37*pGel + 463*pAgua) + " ml");
  if (comResto){
    garrafa.nivel(nivelG);
    garrafa.mistura(-100, t);                         // tudo que está na garrafa já é coco, ora concentrado, ora diluído
    garrafa.concentrado(1 - suave(faixa(p, .81, .93)));
    caustica.visible = garrafa.grupo.visible;
    const kC = (DIST + 2.9)/DIST;                     // o plano fica atrás da garrafa: compensa a perspectiva, senão o brilho escorrega para o centro da tela
    caustica.position.set(gx*kC, (garrafa.grupo.position.y + .12*escG)*kC, -2.9);
    caustica.scale.set(9.5*escG, 3.2*escG, 1);
    caustica.material.opacity = .28*pGar;
  }

  // o sachê vira de cabeça para baixo por cima da boca da garrafa
  const bocaGX = gx, bocaGY = gyBase + GARRAFA.ALT_BOCA*escG;
  const hDesp = (estreito ? .32 : .36)*vh;
  let escS = escalaPx(entre(sh, hDesp, pDesp), MEDIDAS.A)*escCena;
  const giro = entre(0, -rad(128), pDesp);      // horário: a boca vai para a direita, sobre a garrafa
  // posição desejada da boca do sachê: um pouco acima e à esquerda da boca da garrafa
  const alvoBocaX = bocaGX - 1.6*escG, alvoBocaY = bocaGY + 3.4*escG;
  // a boca fica em (0, corte, 0) local; com rz = giro, o deslocamento do centro até a boca é rotacionado
  const dBoca = MEDIDAS.corte*escS;
  const centroDespX = alvoBocaX + dBoca*Math.sin(giro), centroDespY = alvoBocaY - dBoca*Math.cos(giro);
  let px = entre(mundoX(sx), centroDespX, pDesp), py = entre(mundoY(sy), centroDespY, pDesp);
  ry = entre(ry, Math.PI*2 + .45, pDesp); rx = entre(rx, .05, pDesp);

  // o sachê solto no palco não invade o cabeçalho, a legenda nem o cartão: projeta os oito cantos da caixa dele
  // (o giro em perspectiva e a inclinação deixam os cantos mais altos do que a altura nominal) e empurra, ou encolhe
  // se nem assim couber. Entra depois de sair do coco e sai antes do despejo. A flutuação fica de fora e ganha margem.
  const pesoFaixa = faixa(p, .22, .27)*(1 - faixa(p, .565, .585));
  if (pesoFaixa > 0){
    eTmp.set(rx, ry, rz + giro); qTmp.setFromEuler(eTmp);
    mTmp.compose(vTmp.set(px, py, 0), qTmp, vTmp2.setScalar(escS));
    let yMin = Infinity, yMax = -Infinity;
    for (let i = 0; i < 8; i++){
      vTmp3.set((i & 1 ? .5 : -.5)*MEDIDAS.L, (i & 2 ? .5 : -.5)*MEDIDAS.A, (i & 4 ? 1 : -1)*MEDIDAS.espessura).applyMatrix4(mTmp).project(cam);
      const yPx = (1 - vTmp3.y)/2*vh;
      if (yPx < yMin) yMin = yPx;
      if (yPx > yMax) yMax = yPx;
    }
    const amp = .72*escS/alturaMundo*vh;                   // amplitude da flutuação, em px
    const topoLivre = bandaTopo + amp + 4, baseLivre = baseEf - .5*amp;
    vTmp3.set(px, py, 0).project(cam);
    const yc = (1 - vTmp3.y)/2*vh;
    const k = Math.min(1, (baseLivre - topoLivre)/Math.max(1, yMax - yMin));
    const yMinK = yc + (yMin - yc)*k, yMaxK = yc + (yMax - yc)*k;
    let dy = 0;
    if (yMinK < topoLivre) dy = topoLivre - yMinK; else if (yMaxK > baseLivre) dy = baseLivre - yMaxK;
    escS *= entre(1, k, pesoFaixa);
    py -= dy/vh*alturaMundo*pesoFaixa;                    // tela para baixo é mundo para baixo
  }

  // saída: sobe até o sachê inteiro ficar acima da borda de cima, endireitando um pouco
  const yForaS = alturaMundo/2 + .6*MEDIDAS.A*escS + 1;
  py = entre(py, yForaS, pSobe);
  const levanta = .35*pSobe;

  // flutuação viva quando parado
  const vivo = reduz ? 0 : (1 - pDesp)*(1 - faixa(p, .88, 1))*vida;   // vida: some devagar depois de uns segundos parado (ver passo)
  const flutY = .18*Math.sin(t*1.1)*vivo*escS*4, flutR = .035*Math.sin(t*.8 + 1)*vivo;

  sache.grupo.visible = opS > .002 && pSobe < 1;
  sache.grupo.position.set(px, py + flutY, 0);
  sache.grupo.scale.setScalar(escS);
  sache.grupo.rotation.set(rx + .02*Math.sin(t*.7)*vivo, ry + flutR, rz + giro + levanta);
  // dentro do coco o sachê inteiro não cabe (é mais alto que a cavidade): enquanto emerge, o que está abaixo da
  // superfície da água é cortado por um plano de recorte que acompanha o coco (inclinado e caindo com ele)
  const recorta = coco && pSai < 1;
  if (recorta !== sache.recortando){
    sache.grupo.traverse(m => { if (m.isMesh) m.material.clippingPlanes = recorta ? [planoAgua] : null; });
    sache.recortando = recorta;
  }
  sache.materiais.forEach(m => { m.transparent = opS < 1; m.opacity = opS; });

  // a tira
  sache.tira.position.set(1.2*pTira + 4.5*pTira*pTira, .9*pTira + 2.6*pTira*pTira, .8*pTira);
  sache.tira.rotation.set(-.5*pTira, .6*pTira, -1.1*pTira);
  const opTira = (1 - Math.max(0, (pTira - .5)/.5))*opS;
  sache.tira.visible = opTira > .002;
  sache.tira.children.forEach(c => { c.material.opacity = opTira; c.material.transparent = opTira < .999; });   // opaca enquanto inteira: transparente o tempo todo, a ordem de desenho abria um degrau no canto do sachê

  /* ====== o jato ====== */
  const opJato = faixa(p, .672, .684)*(1 - faixa(p, .745, .765));   // o gel cai assim que o sachê chega
  const opAgua = faixa(p, .80, .81)*(1 - faixa(p, .905, .915));
  liquidoVivo = comResto && (opJato > .002 || opAgua > .002);
  if (comResto){
    if (garrafa.grupo.visible) garrafa.agitar(Math.max(.5*opJato, opAgua), t, opAgua > .5*opJato ? -.35 : .2, 0);   // escondida, não precisa refazer as ondas
    jato.mesh.visible = opJato > .002;
    if (jato.mesh.visible){
      sache.grupo.updateMatrixWorld(true);
      vTmp.set(0, MEDIDAS.corte, 0).applyMatrix4(sache.grupo.matrixWorld);          // boca do sachê no mundo
      vTmp2.set(0, MEDIDAS.corte + 1.2, 0).applyMatrix4(sache.grupo.matrixWorld).sub(vTmp).normalize(); // direção de saída
      vTmp3.set(bocaGX + .2*escG, garrafa.grupo.position.y + Math.max(.3, nivelG - .4)*escG, 0);                                     // no fundo, sobre o gel que já caiu
      // sai na direção da boca, a gravidade vence e o fio cai quase na vertical dentro do gargalo
      pontosJato[0].copy(vTmp);
      pontosJato[1].copy(vTmp).addScaledVector(vTmp2, .9*escS*3);
      pontosJato[2].set(vTmp3.x, entre(vTmp.y, vTmp3.y, .6), 0);
      pontosJato[3].copy(vTmp3);
      const comp = faixa(p, .672, .70);
      jato.atualizar(pontosJato, comp, .24*escS*2.4, .15*escS*2.4, t);
    }

    /* ====== a água mineral: a garrafinha entra pela direita, inclina sobre a boca e despeja ====== */
    const pGEntra = suave(faixa(p, .755, .81)), pGSai = suave(faixa(p, .915, .95));
    const escW = escG*.64;
    garrafinha.grupo.visible = pGEntra > 0 && pGSai < 1;
    jatoAgua.mesh.visible = false;
    if (garrafinha.grupo.visible){
      const incl = rad(136) + .05*Math.sin(t*1.3)*opAgua;          // corpo para cima e para a direita, boca para baixo
      const alvoX = bocaGX + 1.2*escG, alvoY = bocaGY + 4.2*escG;  // boca da garrafinha um pouco acima e à direita
      const foraX = alturaMundo*(vw/vh)/2 + 14*escW, foraY = alturaMundo/2 + 8*escW;
      const rot = entre(entre(rad(20), incl, pGEntra), rad(20), pGSai);
      garrafinha.grupo.position.set(entre(entre(foraX, alvoX, pGEntra), foraX, pGSai), entre(entre(foraY, alvoY, pGEntra), foraY, pGSai), .4);
      garrafinha.grupo.rotation.set(0, .35, rot);
      garrafinha.grupo.scale.setScalar(escW);
      // água de dentro: começa quase cheia e desce até a boca conforme despeja (o plano é horizontal no mundo)
      garrafinha.grupo.updateMatrixWorld(true);
      const baseY = vTmp.set(0, -GARRAFINHA.ALT + 1, 0).applyMatrix4(garrafinha.grupo.matrixWorld).y;
      const bocaY = garrafinha.grupo.position.y;
      garrafinha.nivelMundo(entre(entre(baseY, bocaY, .25), bocaY - .5*escW, pAgua));
      if (opAgua > .002){
        // o fio sai pela boca, na direção do gargalo, e cai quase na vertical até a superfície que está subindo
        vTmp.set(0, 0, 0).applyMatrix4(garrafinha.grupo.matrixWorld);
        vTmp2.set(0, 1, 0).applyMatrix4(garrafinha.grupo.matrixWorld).sub(vTmp).normalize();
        vTmp3.set(bocaGX - .35*escG, garrafa.grupo.position.y + Math.max(.3, nivelG - .5)*escG, 0);
        pontosJato[0].copy(vTmp);
        pontosJato[1].copy(vTmp).addScaledVector(vTmp2, 1.1*escW);
        pontosJato[2].set(vTmp3.x, entre(vTmp.y, vTmp3.y, .55), 0);
        pontosJato[3].copy(vTmp3);
        jatoAgua.mesh.visible = true;
        jatoAgua.atualizar(pontosJato, faixa(p, .80, .825), .42*escW, .3*escW, t);
      }
    }
  }

  if (modo === ESTADO || !pronto) return;
  if (modo !== AQUECER){ const pr = prDesejado(p); if (pr !== prAtual){ prAtual = pr; renderer.setPixelRatio(pr); } }
  // sombra (05/10): o mapa só é redesenhado quando a cena se mexe: rolagem, a flutuação do sachê, medidas novas
  const mexeu = u !== uSombra || (vivo > 0 && t !== tSombra);
  // no celular a sombra (um passe a mais da cena inteira) é refeita a cada 3 quadros durante a rolagem: não se nota (06/10)
  quadrosSombra++;
  if ((mexeu && (!TOQUE || quadrosSombra >= 3)) || forcaSombra || modo === AQUECER){ renderer.shadowMap.needsUpdate = true; uSombra = u; tSombra = t; forcaSombra = false; quadrosSombra = 0; }
  if (modo === AQUECER){
    renderer.setScissorTest(true); renderer.setScissor(0, 0, 1, 1);
    renderer.render(scene, cam);
    renderer.setScissorTest(false);
    forcaSombra = true;            // o próximo quadro de verdade redesenha a sombra do instante certo
    return;
  }
  renderer.render(scene, cam);
};

/* ---------- laço: inércia no scroll e vida no repouso ---------- */
let alvoU = 0, uAtual = 0, rodando = false, tUlt = 0, t0 = performance.now(), visivel = true, quieto = 0;
/* vida (05/10): parado, o sachê flutua por uns 8 s e depois assenta devagar, e o laço para (a GPU descansa e o
   celular não esquenta, o que reduzia o clock e trazia as travadas depois de um tempo). A rolagem acorda tudo.
   Com o gel ou a água caindo, o líquido continua vivo, a 20 fps. */
let vida = 1, liquidoVivo = false, fotoAtual = 0;
const QUIETO_MAX = 8000;
const tempoAgora = () => tFixo !== null ? tFixo : (performance.now() - t0)/1000;
function acordar(){ quieto = 0; if (!rodando && !document.hidden){ rodando = true; tUlt = performance.now(); requestAnimationFrame(passo); } }
function lerScroll(){
  if (uFixo !== null){ uAtual = alvoU = trava(uFixo, 0, 1); quadro(uAtual, tFixo !== null ? tFixo : 0); return; }
  alvoU = trava((pageYOffset - topoFilme)/altFilme, 0, 1);
  acordar();
}
/* pixel ratio dinâmico: média de 30 quadros seguidos de rolagem; acima de 22 ms cai para 1,25, de volta quando folga.
   Cada queda segura a volta por um tempo que dobra, para não ficar oscilando. O valor é aplicado no quadro */
let somaDt = 0, nDt = 0, travaPr = 0, esperaPr = 3000;
function ajustarPr(dt, agora){
  if (prFixo || !pronto || (NIVEIS.length < 2 && PR_CLOSE <= PR_TETO)) return;
  if (dt > 100){ somaDt = nDt = 0; return; }
  somaDt += dt; nDt++;
  if (nDt < 30) return;
  const media = somaDt/nDt; somaDt = nDt = 0;
  if (agora < travaPr) return;
  if (media > 22 && nivel < NIVEIS.length - 1){ nivel++; travaPr = agora + 1500; }   // desce rápido, um degrau por vez
  else if (nivel && media < 14){ nivel--; esperaPr = Math.min(esperaPr*2, 60000); travaPr = agora + esperaPr; }   // sobe devagar, para não oscilar
}
function passo(agora){
  if (document.hidden){ rodando = false; return; }
  const dtReal = agora - tUlt;
  const dt = Math.min(50, dtReal) || 16; tUlt = agora;
  const f = 1 - Math.exp(-dt/(TOQUE ? 70 : 130));
  uAtual += (alvoU - uAtual)*f;
  const parado = Math.abs(alvoU - uAtual) < .00025;
  if (parado) uAtual = alvoU; else ajustarPr(dtReal, agora);
  // parado há muito tempo: a flutuação some em ~1,5 s; ao rolar, volta em ~0,8 s
  quieto = parado ? quieto + dt : 0;
  vida = quieto > QUIETO_MAX ? Math.max(0, vida - dt/1500) : Math.min(1, vida + dt/800);
  const t = tFixo !== null ? tFixo : (agora - t0)/1000;
  quadro(uAtual, t);
  // parado: continua só enquanto o palco está na tela e algo ainda se mexe; a 30 fps (20 com o líquido) para poupar bateria
  const precisaVida = pronto && !reduz && visivel && uAtual < .97 && tFixo === null && (vida > 0 || liquidoVivo);
  if (parado && !precisaVida){ rodando = false; return; }
  if (parado){ setTimeout(() => requestAnimationFrame(passo), vida > 0 ? 33 : 50); return; }
  requestAnimationFrame(passo);
}

/* vídeo da praia (02/10, desempenho 05/10): só no desktop (o vertical do celular é outra foto, e o vídeo não casa com
   ela), pedido só depois do coco e das texturas, e só toca enquanto a praia aparece de verdade (abertura). Depois ela
   fica a 32% por trás do filme, onde o movimento não se percebe: o vídeo pausa no último quadro e volta ao subir.
   Com o laço parado, cada quadro novo do vídeo é desenhado sozinho (requestVideoFrameCallback). */
let video = null, videoTex = null;
const comVideo = !reduz && !params.has("semvideo") && !params.has("claro") && innerWidth/innerHeight >= .9;
function cuidarVideo(){
  if (!comVideo || !pronto) return;
  const deve = visivel && !document.hidden && fotoAtual > .01;
  if (!video){
    if (!deve) return;
    video = document.createElement("video");
    Object.assign(video, { muted: true, loop: true, playsInline: true, autoplay: false, preload: "auto" });
    video.setAttribute("muted", ""); video.setAttribute("playsinline", "");
    video.src = (A + "heroi-praia.mp4");
    video.addEventListener("playing", () => {
      if (videoTex) return;
      videoTex = new THREE.VideoTexture(video); videoTex.colorSpace = THREE.NoColorSpace; videoTex.minFilter = THREE.LinearFilter; videoTex.generateMipmaps = false;
      fundo.uniformes.tFoto.value = videoTex; medir(); lerScroll();
      if ("requestVideoFrameCallback" in video){
        const aoQuadro = () => {
          video.requestVideoFrameCallback(aoQuadro);
          if (!rodando && pronto && visivel && !document.hidden && renderer) renderer.render(scene, cam);
        };
        video.requestVideoFrameCallback(aoQuadro);
      }
    }, { once: true });
    window.__praiaVideo = video;
  }
  if (deve && video.paused) video.play().catch(() => {});
  else if (!deve && !video.paused) video.pause();
}

if (!reduz && "IntersectionObserver" in window){
  new IntersectionObserver(l => {
    visivel = l[0].isIntersecting; if (visivel) lerScroll();
    cuidarVideo();   // vídeo da praia só toca com o palco na tela
  }, { threshold:0 }).observe(palco);
}
// aba escondida: para o laço e o vídeo; ao voltar, retoma do ponto atual
document.addEventListener("visibilitychange", () => { if (!document.hidden){ forcaSombra = true; lerScroll(); } cuidarVideo(); });
addEventListener("scroll", lerScroll, { passive:true });
// no celular a barra de endereço aparece e some ao rolar e muda só a altura: não remede nem realoca o canvas por isso
let largAnt = innerWidth, altAnt = innerHeight;
addEventListener("resize", () => {
  if (TOQUE && innerWidth === largAnt && Math.abs(innerHeight - altAnt) < 160) return;
  largAnt = innerWidth; altAnt = innerHeight;
  medir(); lerScroll();
});
addEventListener("load", () => { medir(); lerScroll(); });
if (document.fonts) document.fonts.ready.then(() => { medir(); lerScroll(); });   // a altura da legenda muda quando a fonte chega
medir(); lerScroll();
// depuração: ?y=4400 rola a página depois de carregar, para testar o laço com scroll de verdade
if (params.has("y")) addEventListener("load", () => setTimeout(() => scrollTo(0, parseFloat(params.get("y"))), 300));
if (params.has("log")) { const _q = quadro; quadro = function(u, t, m){ console.log("quadro u=" + u.toFixed(3) + " t=" + t.toFixed(2)); return _q(u, t, m); }; }
// o pacote de arquivo único (rotas por hash) chama isto ao voltar para a home
window.__filme = { medir, ler: lerScroll };
